<div *ngIf="showClearAll$ | async" class="clear-all-filters">
  <span (click)="clearFilter()">{{ 'search.listing.sidenav.clearall.title' | translate }}</span>
</div>
